const getUnixTimestamp = (value: string) => {
    return Math.floor(new Date(value).getTime() / 1000)
}

export {getUnixTimestamp}
